import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/congratulations.svg'


const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Select Workstations", -1)
const _hoisted_4 = { class: "modal_form" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Choosing multiple workstations enables trade contractors to receive leads and work with their friends or colleagues. ", -1)
const _hoisted_8 = {
  key: 2,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full"
}
const _hoisted_9 = {
  key: 3,
  class: "workstation__list__content"
}
const _hoisted_10 = { class: "workstation__results" }
const _hoisted_11 = { class: "workstation__companies__list" }
const _hoisted_12 = {
  key: 1,
  class: "workstation__companies-item__content"
}
const _hoisted_13 = {
  key: 1,
  class: "company-img"
}
const _hoisted_14 = { class: "company-text" }
const _hoisted_15 = { class: "modal_content_footer" }
const _hoisted_16 = { class: "modal_content" }
const _hoisted_17 = { class: "header" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "modal_form" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal_img" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("h3", null, "Congratulations!"),
  /*#__PURE__*/_createElementVNode("p", null, " The preferred contractor for the property owners has been successfully accepted at the selected workstation(s). You are all set to collaborate and work together. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_ProfileThumbnail = _resolveComponent("ProfileThumbnail")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isShowSuccessFullyAccepted)
      ? (_openBlock(), _createBlock(_component_CommonDialog, {
          key: 0,
          isShowHeader: false,
          isShowBackButton: false,
          className: ['select_workstation_modal'],
          width: "670px",
          "max-width": "100%"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  onClick: $setup.onClickCloseButton,
                  variant: "text"
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                (
              $props.acceptInvitationDetails?.type ===
              $setup.UserNotificationType.PROPERTY_USER_CONNECTION
            )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Select one or multiple workstations to accept the connection for the property owners. "))
                  : (_openBlock(), _createElementBlock("p", _hoisted_6, " Select one or multiple workstations to accept the preferred contractor for the property owners. ")),
                _hoisted_7,
                ($setup.loadingImages)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_Loader, { show: $setup.loadingImages }, null, 8, ["show"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_v_text_field, {
                        modelValue: $setup.searchTerm,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchTerm) = $event)),
                        "prepend-inner-icon": "mdi-magnify",
                        density: "compact",
                        placeholder: "Search Workstation Names",
                        variant: "outlined",
                        "hide-details": "",
                        "single-line": ""
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", null, [
                          _createElementVNode("span", null, _toDisplayString($setup.filteredWorkstations?.length), 1),
                          _createTextVNode(" Results | ")
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", null, _toDisplayString($setup.getSelectedWorkstationIds?.length), 1),
                          _createTextVNode(" Selected ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredWorkstations, (workstation, index) => {
                          return (_openBlock(), _createBlock(_component_v_card, {
                            class: _normalizeClass(["workstation__companies-item", { selected: workstation.selected }]),
                            key: index,
                            onClick: ($event: any) => ($setup.handleSelectionChange(workstation))
                          }, {
                            default: _withCtx(() => [
                              ($setup.loadingImages)
                                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                                    key: 0,
                                    type: "list-item-avatar"
                                  }))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    (workstation.attachmentSource)
                                      ? (_openBlock(), _createBlock(_component_ProfileThumbnail, {
                                          key: 0,
                                          class: "company-img",
                                          src: workstation.attachmentSource
                                        }, null, 8, ["src"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                          _createVNode(_component_UserProfileLogo, {
                                            userName: workstation?.name
                                          }, null, 8, ["userName"])
                                        ])),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("p", null, _toDisplayString(workstation
                          ? workstation?.name === "Default"
                            ? workstation?.user?.firstName +
                              " " +
                              workstation?.user?.lastName
                            : workstation?.name
                          : ""), 1),
                                      _createElementVNode("span", null, _toDisplayString(workstation
                          ? workstation?.user?.userBusinessDetails?.type ==
                            $setup.BusinessDetailTypeEnum.LIMITED_COMPANY
                            ? "LTD Company Workstation"
                            : workstation?.name === "Default"
                            ? "Personal Account"
                            : "Sole Trader Workstation"
                          : ""), 1)
                                    ])
                                  ]))
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        }), 128))
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_btn, {
                  onClick: $setup.onClickCloseButton,
                  class: "button button-purple-border"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("CANCEL")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createTextVNode(" " + _toDisplayString($setup.getSelectedWorkstationIds.value) + " ", 1),
                _createVNode(_component_v_btn, {
                  onClick: $setup.onClickSaveButton,
                  loading: $setup.isLoading,
                  disabled: !$setup.getSelectedWorkstationIds?.length,
                  class: "button button-orange"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Done")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.isShowSuccessFullyAccepted)
      ? (_openBlock(), _createBlock(_component_CommonDialog, {
          key: 1,
          isShowHeader: false,
          isShowBackButton: false,
          className: ['accepted_workstation_modal'],
          width: "570px",
          height: "auto"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  onClick: $setup.onClickCloseButton,
                  variant: "text"
                }, null, 8, ["onClick"])
              ]),
              _hoisted_18,
              _createVNode(_component_v_btn, {
                onClick: $setup.onClickDoneButton,
                class: "button button-orange"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Done")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}